var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconYt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 42H35.5C39.09 42 42 39.09 42 35.5V12.5C42 8.91 39.09 6 35.5 6H12.5C8.91 6 6 8.91 6 12.5V35.5C6 39.09 8.91 42 12.5 42Z",
    fill: "url(#paint0_linear_7397_8497)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4611 29.6689C35.2216 30.8907 34.2044 31.8218 32.9476 31.9964C30.9725 32.2871 27.6807 32.6362 23.97 32.6362C20.3193 32.6362 17.0275 32.2871 14.9924 31.9964C13.7356 31.8218 12.7178 30.8907 12.4789 29.6689C12.2395 28.3309 12 26.3526 12 23.9089C12 21.4653 12.2395 19.4869 12.4789 18.1489C12.7184 16.9271 13.7356 15.996 14.9924 15.8215C16.9675 15.5307 20.2593 15.1816 23.97 15.1816C27.6807 15.1816 30.9125 15.5307 32.9476 15.8215C34.2044 15.996 35.2222 16.9271 35.4611 18.1489C35.7005 19.4869 36 21.4653 36 23.9089C35.94 26.3526 35.7005 28.3309 35.4611 29.6689Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2734 28.0374V19.7819C21.2734 19.3766 21.7251 19.1344 22.0627 19.3597L28.2547 23.4877C28.5563 23.6884 28.5563 24.1314 28.2547 24.3326L22.0627 28.4606C21.7251 28.6848 21.2734 28.4432 21.2734 28.0374Z",
    fill: "url(#paint1_linear_7397_8497)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7397_8497",
    x1: 12.3949,
    y1: 8.10488,
    x2: 46.0335,
    y2: 32.5693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7397_8497",
    x1: 22.5538,
    y1: 19.8156,
    x2: 30.3571,
    y2: 24.2267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F44F5A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.443,
    stopColor: "#EE3D4A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E52030"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconYt);
export default __webpack_public_path__ + "static/media/icon_yt.dab302297e100677172b5ae4991c23cf.svg";
export { ForwardRef as ReactComponent };